export const POP_UP_STYLE = { opacity: 0.7 };
